import { StockStatus } from '@storefront/lib-global/codegen/types';
import type { Variant } from '@storefront/lib-global/codegen/types';

export const areAllVariantsWithNotificationsDisabledOrInStock = (variants: Variant[]): boolean =>
  variants.every(
    (variant) =>
      !variant.backInStockNotificationsEnabled ||
      (variant.backInStockNotificationsEnabled && variant.stock.status === StockStatus.INSTOCK),
  );
